/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DetachBindingRequestBody = {
  id: string;
  principalId: string;
  userSessionIssuerId: string;
};

/** @internal */
export type DetachBindingRequestBody$Outbound = {
  id: string;
  principal_id: string;
  user_session_issuer_id: string;
};

/** @internal */
export const DetachBindingRequestBody$outboundSchema: z.ZodMiniType<
  DetachBindingRequestBody$Outbound,
  DetachBindingRequestBody
> = z.pipe(
  z.object({
    id: z.string(),
    principalId: z.string(),
    userSessionIssuerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      principalId: "principal_id",
      userSessionIssuerId: "user_session_issuer_id",
    });
  }),
);

export function detachBindingRequestBodyToJSON(
  detachBindingRequestBody: DetachBindingRequestBody,
): string {
  return JSON.stringify(
    DetachBindingRequestBody$outboundSchema.parse(detachBindingRequestBody),
  );
}
